import { render, staticRenderFns } from "./DraftCaseRow.vue?vue&type=template&id=545472b0"
import script from "./DraftCaseRow.vue?vue&type=script&lang=js"
export * from "./DraftCaseRow.vue?vue&type=script&lang=js"
import style0 from "./DraftCaseRow.vue?vue&type=style&index=0&id=545472b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports